import axios from '@/http'


// 绑定爱米用户
export function thirdPartnerBind(data) {
    return axios({
        url: '/api/third-partner/bind',
        method: 'POST',
        data
    })
}